import { ArrowRightIcon, ArrowsDownUpIcon } from '@phosphor-icons/react';
import ModalCloseButton from '../generic/ModalCloseButton';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PurchaseBatchModal = ({ packGroup, onClose, isPurchase }) => {
  const navigate = useNavigate();
  const [selectValue, setSelectValue] = useState(null);
  const packs = packGroup?.packs;

  const onPackSelectChange = (value) => {
    const selectedPack = packs.find((pack) => pack.title === value);
    setSelectValue(selectedPack);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-lg p-6 w-full max-w-md">
        <ModalCloseButton onClick={onClose} />
        <div className="flex flex-col gap-2 justify-center mb-4">
          <h3 className="text-lg font-semibold text-[var(--q3-neutral-default)]">
            Please select the pack you want to enroll in
          </h3>
          <Select value={selectValue?.title || ''} onValueChange={onPackSelectChange}>
            <SelectTrigger className="w-auto rounded-full">
              <SelectValue placeholder="Select Pack" />
            </SelectTrigger>
            <SelectContent position="popper" sideOffset={4} align="start" className="max-w-[calc(100vw-2rem)]">
              {packs.map((option) => (
                <SelectItem key={option.title} value={option.title}>
                  {option.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-3 mt-6">
          <Button
            // variant="outline"
            className="group flex flex-row shadow-none border-none !bg-[var(--q3-danger-normal)] hover:scale-100"
            disabled={!selectValue}
            onClick={() => {
              if (!isPurchase) {
                navigate(`/v3/${selectValue._id}/tests`);
              } else {
                window.open(
                  `https://pay.mathongo.com?item_id=${selectValue?.paymentItemId}&coupon=${packGroup.couponCode}&utm_source=quizrr&utm_medium=non_purchased_dashboard&utm_campaign=quizrr_dashboard`,
                  '_blank',
                );
              }
            }}
          >
            {isPurchase ? 'Buy Now' : 'View Details'}
            <ArrowRightIcon className="group-hover:translate-x-1 transition-all duration-300" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PurchaseBatchModal;
